let $ = jQuery.noConflict(),
	devMode,
    appearOnScroll,
	scrollController,
	foregroundContent,
	body,
	mobileCheck = false,
	currentY,
	scrollBar,
	noTouchEvent,
	pageTransition,
	resizeCallbacks = [],
	barbaCallbacks = [];

$(function () {
	initStarterKit();

	// Composants Mobile & Desktop

	// home
    new Home();
	new PopupHome();

    // News
    // new News();

	// Landing
	new Landing();

	new SplitTheText();
	new NavMain();
	new Banner();
	new ContactForm();

	// program
	new NavProgram();
	new ProgramMap();

	// sliders
	new SliderProgram();
	new SliderTestimony();
	new Bot();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	}else{
		// Composants Desktop uniquement
	}
});

function initStarterKit() {
	body = $('body');
	devMode = localStorage.getItem('devMode');
	debugBootstrap();
	foregroundContent = $('.foreground-content');
	noTouchEvent = $('html').hasClass('no-touchevents');
	new SmoothScroll();
	appearOnScroll = new AppearOnScroll();
	mobileCheck = new MobileCheck();
	new DataLink();
	new Forms();
	new MadeByMcube();
}
